import { create } from "zustand";

interface DataHubState {
  isConfigEdited: boolean;
  setIsConfigEdited: (isConfigEdited: boolean) => void;
}

export const useDataHubStore = create<DataHubState>((set) => ({
  isConfigEdited: false,
  setIsConfigEdited: (isConfigEdited: boolean) => set({ isConfigEdited }),
}));

export default useDataHubStore;
